import { useTranslation } from '@hbs-us/ui';

import { StatusBadge, type StatusTone } from '../../_money/StatusBadge.js';
import type { EstimateStatus } from '../contractsMirror.js';

/**
 * The estimate money-status pill (legacy `statusBadgeClass()`). Maps the server
 * status union onto a locked status tone (UI-SPEC Color "Status (estimate)"
 * table) — Approved/Converted → green, Rejected/Expired → red, Ready/Sent →
 * amber, Draft → neutral, Archived → secondary. The status meaning is ALWAYS
 * carried by the badge TEXT, never color alone (A11Y-01).
 */

const STATUS_TONE: Record<EstimateStatus, StatusTone> = {
  approved: 'success',
  converted: 'success',
  rejected: 'destructive',
  expired: 'destructive',
  ready: 'warning',
  sent: 'warning',
  archived: 'neutralBlue',
  draft: 'neutral',
};

export function EstimateStatusBadge({
  status,
  archived,
}: {
  status: EstimateStatus;
  archived?: boolean;
}) {
  const { t } = useTranslation();

  if (archived) {
    return <StatusBadge tone="neutralBlue">{t('estimates:status.archived')}</StatusBadge>;
  }
  return <StatusBadge tone={STATUS_TONE[status]}>{t(`estimates:status.${status}`)}</StatusBadge>;
}
